<script>
import {opusIconsPicto,opusIconsLine} from "./opusIconPath.js";
// ur-icon 은 icon을 표시하는 컴포넌트입니다. 지정되는 icon 이름에 따른 icon을 표시합니다.
// #ur-icon is a component that displays icons. Displays the icon according to the specified icon name.
export default {
    name: "ur-icon",
    // Why functional?
    // svn object가 static하게 component정의부에만 한벌 존재하고
    // 컴포넌트 사용시에 복사본 instance state에는 포함되길 원하지않음.
    functional: true,
    props: {
        // $ver: v0.2.0
        // 아이콘의 모양입니다. 아이콘에 대한 설명은 <a href="/#/dev/comp/icon">링크</a>를 참조하십시오.
        // # Icon to display. Enter a value by referring to the OPUS Icon name
        // #See the <a href="/#/dev/comp/icon">links</a> for a description of the icons.
        icon: {type: String},
        // $ver: v0.2.0
        // 아이콘의 형태입니다. 'line', 'picto' 의 값을 입력할 수 있습니다.
        // # The type of the control.  You can enter values ​​for 'line', 'picto'.
        iconType: {
            type: String
        },
        // $ver: v0.2.1
        // Picto(gram)형태의 아이콘을 보여줍니다.
        // # It show pictogram type icon.
        picto : {type:Boolean},
        // $ver: v0.2.1
        // Line 형태의 아이콘을 보여줍니다.
        // 따로 지정하지 않더라도 default값으로 line 형태로 지정됩니다.
        // # It show line type icon
        // # If props doesn't set icon type, automaticaly set line type default.
        line : {type:Boolean},
        // $ver: v0.1.0
        // 아이콘 크기 입니다.
        // #This is icon size.
        // $default: inherit
        iconSize: {type: [String, Number]},
        // $ver: v0.1.0
        // 여백의 여부입니다.
        // #Whether the icon spacing
        // $default: false
        spacing: {type: Boolean, default: false},
        default: {type:Boolean, default: false},
        // $ver: v0.1.0
        // Primary 색상 여부입니다.
        // #Whether to be primary color
        // $default: false
        primary: {type: Boolean, default: false},
        // $ver: v0.1.0
        // Point 색상 여부입니다.
        // #Whether the Point color
        // $default: false
        point: {type: Boolean, default: false},
        // $ver: v0.2.0
        // 아이콘의 색깔입니다.
        // # The color of the control.
        // $default: 'normal'
        color: {type:String, default: undefined},
        // $ver: v0.1.0
        // 큰크기 사이즈로 표현합니다.
        // #Expressed in large size.
        // $default: false
        large : {type: Boolean, default: false},
        // $ver: v0.1.0
        // 중간크기 사이즈로 표현합니다.
        // #Expressed in medium size.
        // $default: false
        medium : {type: Boolean, default: false},
        // $ver: v0.1.0
        // 작은크기 사이즈로 표현합니다.
        // #Expressed in small size.
        // $default: false
        small: {type: Boolean, default: false},
        // $ver: v0.1.0
        // 아주 작은 크기 사이즈로 표현합니다.
        // #Expressed in extra small size.
        // $default: false
        xsmall: {type: Boolean, default: false},
        // $ver: v0.1.0
        // 아이콘의 크기가 컨테이너에 꽉 차도록 표현합니다.
        // #Makes the icon fill the container.
        // $default: false
        full: {type: Boolean, default: false},

        /* font-awesome */
        // $ver: v0.1.0
        // $hide:
        brand   : Boolean,
        // $ver: v0.1.0
        // $hide:
        regular : Boolean,
        // $ver: v0.1.0
        // $hide:
        light   : Boolean,
        // $ver: v0.1.0
        // $hide:
        old     : Boolean,
        // $ver: v0.1.0
        // $hide:
        fab     : Boolean,
        // $ver: v0.1.0
        // $hide:
        far     : Boolean,
        // $ver: v0.1.0
        // $hide:
        fal     : Boolean,
        // $ver: v0.1.0
        // $hide:
        fa      : Boolean,

        /* abbr */
        // $ver: v0.1.0
        // 아이콘의 형태입니다. 'line', 'picto' 의 값을 입력할 수 있습니다.
        // # The type of the control.  You can enter values ​​for 'line', 'picto'.
        // $default: 'line'
        type: {
            type: String,
            validator: function(value) {
                return !value || ['line', 'picto'].indexOf(value) !== -1;
            }
        },
        //$ ver:v0.2.0
        // 아이콘의 크기입니다. 'small', 'medium' 의 값을 입력할 수 있습니다.
        // # The type of the control.  You can enter values ​​for 'small', 'medium'.
        size: {type: [String, Number]},
        // $ver: v0.1.0
        // $abbr: default
        dft: {type:Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: primary
        prim: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: point
        pnt: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: color
        col: {type: String, default: undefined},
        // $ver: v0.1.0
        // $abbr: large
        lg: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: medium
        md: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: small
        sm: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: xsmall
        xs: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 포커스를 줄지 여부를 결정합니다.
        // #Makes the icon fill the container.
        // $default: false
        focusable: {type:Boolean, default: false} // this is for IE. On IE, tab key make unnecessary focus to svg tag
    },
    /*NOSONAR*/render(h, {props, data,listeners, children = []}) {
        let opusIcons = {};
        let cType = props.iconType || props.type;
        if(!cType) {
            cType = props.picto ? 'picto' : 'line'; // line props는 별도로 체크 안함. default value 
        }
        if (cType === 'picto') {
            opusIcons = opusIconsPicto;
        } else if (cType === 'line') {
            opusIcons = opusIconsLine;
        }
        let cColor ='';
        if (props.primary||props.prim) { cColor= 'primary'; }
        else if (props.point||props.pnt) { cColor= 'point'; }
        else if (props.default||props.dft) { cColor= 'default'; }
        else if (!!props.color||!!props.col) { cColor= props.color||props.col; }

        let cSize = '' ;
        if(props.large || props.lg) {cSize= 'large';}
        else if(props.medium || props.md) {cSize= 'medium';}
        else if(props.small || props.sm) {cSize= 'small';}
        else if(props.xsmall || props.xs) {cSize= 'xsmall';}
        else if(props.full) {cSize= 'full';}

        let customSize = props.iconSize || props.size;
        if(typeof customSize === 'number') {customSize = customSize + 'px';}

        let iconName = props.icon || children.pop().text;
        let options = {
            class: [
                'ur-icon',
                'ur-icon--'+cType,
                cColor && 'ur-icon--'+cColor,
                cSize &&'ur-icon--'+cSize,
                props.spacing && 'ur-icon--spacing'
            ],
            style: {
                fontSize: customSize
            },
            on: listeners
        };
        if(data.class) {
            if(Array.isArray(data.class)) {
                options.class = options.class.concat(data.class);
            }
            if(typeof data.class === 'string' || typeof data.class === 'object') {
                options.class.push(data.class);
            }
        }
        if(data.style) {
            options.style = Object.assign(data.style, options.style);
        }
        let child = [];
        if (opusIcons[iconName] !== undefined) {
            // !!! BE CAREFUL !!! this component uses v-html(innerHTML).
            // So, opusIcons object MUST NOT contain XSS vulnerability.
            options.class.push('opus-icon__'+iconName);
            let svg = opusIcons[iconName];
            if(!props.focusable) {svg = svg.replace('<svg ','<svg focusable="false" ');}
            options.domProps={innerHTML:svg};
        } else {
            // 1. icon class
            options.class.push('fa-'+iconName);
            // 2. type class
            if     ( props.brand )   { options.class.push('fab'); }
            else if( props.fab)      { options.class.push('fab'); }
            else if( props.regular ) { options.class.push('far'); }/* pro only */
            else if( props.far )     { options.class.push('far'); }/* pro only */
            else if( props.light)    { options.class.push('fal'); }/* pro only */
            else if( props.fal)      { options.class.push('fal'); }/* pro only */
            else if( props.old)      { options.class.push('fa'); }/* font-awesome 4.0*/
            else if( props.fa)       { options.class.push('fa'); }/* font-awesome 4.0*/
            else { options.class.push("fas"); }
        }
        return h('i',Object.assign(data, options));
    },
}
</script>
